import { ImToken } from './ImToken'

export const imtoken = new ImToken()
